import { createApi, QueryReturnValue } from '@reduxjs/toolkit/query/react'
import {
  IBBL,
  IBBLApplications,
  IBBLBase,
  IBBLSettings,
} from 'shared/models/BBL'
import { IFeatureToggle } from 'shared/models/FeatureToggle'
import axiosBaseQuery from 'shared/utils/axiosBaseQuery'
import settleAllQueries from 'shared/utils/settleAllQueries'

const bblApi = createApi({
  reducerPath: 'bbl',
  baseQuery: axiosBaseQuery({ baseUrl: '/bbl/bbl' }),
  endpoints: (build) => ({
    getBbl: build.query<IBBL, void>({
      async queryFn(_arg, _api, _extraOptions, baseQuery) {
        const base = baseQuery({ url: '', method: 'GET' })
        const settings = baseQuery({ url: '/settings', method: 'GET' })
        const applications = baseQuery({
          url: '/applications',
          method: 'GET',
        })
        const featureToggles = baseQuery({
          url: '/featuretoggles',
          method: 'GET',
        })

        const { resolved, rejected } = await settleAllQueries([
          base,
          settings,
          applications,
          featureToggles,
        ] as Promise<QueryReturnValue<unknown, unknown>>[])

        if (rejected.length) {
          return { error: 'Henting av BBL feilet' }
        }

        const [baseData, settingsData, applicationsData, featureTogglesData] =
          resolved

        const data = {
          ...(baseData as IBBLBase),
          settings: settingsData as IBBLSettings,
          applications: applicationsData as IBBLApplications[],
          featureToggles: featureTogglesData as IFeatureToggle[],
        }

        return { data }
      },
    }),
  }),
})

export default bblApi
export const { useLazyGetBblQuery } = bblApi
